<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div class="grid-two">
  <mat-card class="block">
    <h2>{{ editingId ? 'Edit sponsor' : 'Add sponsor' }}</h2>
    <form class="form-grid" [formGroup]="form" (ngSubmit)="save()">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Tier</mat-label>
        <input matInput formControlName="tier" />
      </mat-form-field>
      <app-image-url-field
        class="full"
        [challengeId]="id"
        controlName="logoUrl"
        label="Logo"
        placeholderType="sponsor"
        [displayUrl]="editingDisplayUrl"
      ></app-image-url-field>
      <mat-form-field appearance="outline">
        <mat-label>Website URL</mat-label>
        <input matInput formControlName="websiteUrl" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Sort order</mat-label>
        <input matInput type="number" formControlName="sortOrder" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Account ID (optional)</mat-label>
        <input matInput formControlName="accountId" />
      </mat-form-field>
      <div class="actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || busy">Save</button>
        <button mat-button type="button" (click)="reset()" [disabled]="busy">Clear</button>
      </div>
    </form>
  </mat-card>

  <mat-card class="block">
    <h2>Sponsors</h2>
    <div class="list" *ngIf="sponsors.length; else empty">
      <div class="row" *ngFor="let s of sponsors">
        <div class="row-main">
          <img class="thumb" [src]="sponsorImageSrc(s)" [alt]="s.name" />
          <div>
          <strong>{{ s.name }}</strong>
          <div class="meta">{{ s.tier || '—' }} · order {{ s.sortOrder }}</div>
          </div>
        </div>
        <div class="actions">
          <button mat-button type="button" (click)="edit(s)">Edit</button>
          <button mat-button type="button" (click)="remove(s.id)">Delete</button>
        </div>
      </div>
    </div>
    <ng-template #empty><p class="empty">No sponsors yet.</p></ng-template>
  </mat-card>
</div>
